export default {
  state: {
    discount: 0
  },

  mutations: {
    updateDiscount(state, payload) {
      state.discount = payload;
    }
  }
};
